<template>
  <div class="main-container myorder my-orders-page mt30">
    <!--<code>    {{ orders }}</code>-->
    <div class="container-fluid device-max-area">
      <div class="row">
        <div class="col-md-12">
          <!-- Modal -->
          <div id="cancel_order_modal" class="modal cancel-modal fade" role="dialog">
            <div class="modal-dialog">

              <!-- Modal content-->
              <div class="modal-content text-center">
                <div class="modal-body">
                  <img class="status-icon mt15" src="@/assets/images/info-red.png" alt="">
                  <h2>Are you sure you want to Cancel this Order?</h2>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-warning mt5" data-dismiss="modal">CLOSE</button>
                  <button type="button" class="btn btn-success" @click="cancelThisOrder">Yes</button>
                </div>
              </div>

            </div>
          </div>
          <!--<div class="panel panel-success"v-if="" v-if="order_message">-->
          <!--<div>{{orders}}</div>-->
          <!--</div>-->
          <div class="panel panel-default myorders">
            <div class="panel-heading maintitle">
              <h4>My Orders</h4>
            </div>
             <div class="panel-body">
              <div class="panel-group" id="accordion" v-for="(order ,counter) in orders">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a data-toggle="collapse" data-parent="#accordion" :href="'#order_id_'+order.id">
                        <span>ORDER ID: <b class="base-color">#{{order.id}}</b></span>
                        <span class="ml30  odate"><i class="fa fa-calendar-o " aria-hidden="true"></i>
                          {{order.created_at | formatDate}}</span>
                        <span class="pull-right order-amount"><span>Amount: <b class="base-color"> {{
                            orderTotal(order.order_total,order.delivery_charge,order.coupon_discount_amount).toFixed(2)
                          }} &#8364; </b> &nbsp;&nbsp;</span> <i class="fa fa-angle-down"></i></span>
                      </a>
                    </h4>
                  </div>
                  <div :id="'order_id_'+order.id" class="panel-collapse collapse" v-bind:class="{ in: counter == 0 }">
                    <div class="panel-body print-area">

                      <div class="status-msg" v-if="order.active_status==0">
                        <img src="@/assets/images/info.png" width="18px">&nbsp; Your order is in pending Status you will
                        get confirmation soon.
                        <!--<img src="@/assets/images/close.png" class="pull-right cursor"  width="18px">-->
                      </div>
                      <div class="status-msg" v-else-if="order.active_status==1">
                        <img src="@/assets/images/info-blue.png" width="18px">&nbsp; Your order has been Approved
                        Successfully.
                      </div>
                      <div class="status-msg" v-else-if="order.active_status==2">
                        <img src="@/assets/images/info.png" width="18px">&nbsp; Your order is in Transit.
                      </div>
                      <div class="status-msg" v-else-if="order.active_status==3">
                        <img src="@/assets/images/info-green.png" width="18px">&nbsp; Your order is completed
                        successfully
                        Delivered.
                      </div>
                      <div class="status-msg" v-else-if="order.active_status==4">
                        <img src="@/assets/images/info-red.png" width="18px">&nbsp; Your order is Cancelled.
                      </div>
                      <div class="order-items">
                        <div class="row">
                          <div class="col-lg-8 col-md-7 col-sm-7">
                            <h3 class="c-title mb10">Billing Details</h3>
                            <p class="green-color thanks-msg mb10">Thank you for your Order. </p>
                            <div class="table-responsive no-border">
                              <table class="table  table-responsive order-summary">
                                <tr>
                                  <td>ORDER ID<br>
                                    <span class="base-color">#{{order.id}}</span>
                                  </td>
                                  <td>DATE<br>
                                    <span class="base-color">{{order.created_at | formatDate}}</span>
                                  </td>
                                  <td>PAYMENT METHOD<br>
                                    <span class="base-color" v-if="order.payment_type==1"> Card -
                                      #{{order.transaction_number}}</span>
                                    <span class="base-color" v-else-if="order.payment_type==2"> Cash On Delivery -
                                      #{{order.transaction_number}}</span>
                                    <span class="base-color" v-else-if="order.payment_type==3"> Nagad -
                                      #{{order.transaction_number}}</span>
                                    <span class="base-color" v-else-if="order.payment_type==4"> Deposit Money -
                                      #{{order.transaction_number}}</span>
                                    <span class="base-color" v-else></span>
                                  </td>
                                  <td>TOTAL<br>
                                    <span class="base-color">  {{
                                        orderTotal(order.order_total,order.delivery_charge,order.coupon_discount_amount).toFixed(2)
                                      }} &#8364;</span>
                                  </td>

                                </tr>
                              </table>
                            </div>

                            <h3 class="c-title">Your Order</h3>
                            <div class="table-responsive no-border">
                              <table class="table  table-responsive  table-striped checkout-table">
                                <thead>
                                <tr>
                                  <th>Product</th>
                                  <th class="text-center">Unit&nbsp;Price</th>
                                  <th class="text-center">Quantity</th>
                                  <th>Total</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in order_items" v-if="order.id==item.order_id">
                                  <td>
                                    <div v-if="globalLanguage=='EN'">
                                      {{ item.name }}
                                    </div>
                                    <div v-else>
                                      {{ item.name_bn }}
                                    </div>
                                  </td>
                                  <td class="text-center"> {{item.unit_price.toFixed(2)}} &#8364; <span
                                    class="text-right pull-right">&#215;</span></td>
                                  <td class="text-center"> {{item.quantity}}</td>
                                  <td> {{item.total_price.toFixed(2)}} &#8364;</td>
                                </tr>
                                <tr class="order-summary-row">
                                  <td colspan="3" class="text-right" v-if="language=='EN'">Cart Subtotal:</td>
                                  <td colspan="3" class="text-right" v-else>সাব টোটাল :</td>
                                  <td class="green-color w500"> {{order.order_total.toFixed(2)}} &#8364;</td>
                                </tr>

                                <tr class="order-summary-row">
                                  <td colspan="3" class="text-right" v-if="language=='EN'">Delivery Charge:</td>
                                  <td colspan="3" class="text-right" v-else>ডেলিভারি চার্জ:</td>
                                  <td class="green-color w500"> {{order.delivery_charge.toFixed(2)}} &#8364;</td>
                                </tr>
                                <tr class="order-summary-row" v-if="order.coupon_discount_amount>0">
                                  <td colspan="3" class="text-right" v-if="language=='EN'">Coupon Discount:</td>
                                  <td colspan="3" class="text-right" v-else>কুপন ডিসকাউন্ট:</td>
                                  <td class="orange-color w500 ">- {{order.coupon_discount_amount}} &#8364;
                                  </td>
                                </tr>
                                <tr class="order-summary-row order-grand-total-row">
                                  <td colspan="3" class="text-right" v-if="language=='EN'">Order Total:</td>
                                  <td colspan="3" class="text-right" v-else>টোটাল এমাউন্ট:</td>
                                  <td class="green-color w500"> {{
                                      orderTotal(order.order_total,order.delivery_charge,order.coupon_discount_amount
                                      ).toFixed(2) }} &#8364;</td>
                                </tr>
                                </tbody>
                              </table>
                              <!--<router-link target='_blank' :to="{ path: '/myorder/'+order.id}"  class="btn btn-base print-btn btn-sm mt15 pull-right"><i class="fa fa-print"></i> PRINT INVOICE</router-link>-->

                              <div v-if="order.active_status==3">

                              </div>
                              <div v-else-if="order.active_status==4">

                              </div>
                              <div v-else-if="order.active_status==1">

                              </div>
                              <div v-else-if="order.active_status==2">
                              </div>
                              <div v-else>
                                <button class="btn btn-orange cancel-btn btn-sm mt15 pull-right"
                                        @click="openCancelModal(order.id)" data-toggle="modal"
                                        data-target="#cancel_order_modal"> <i class="fa fa-ban" aria-hidden="true"></i> CANCEL
                                  ORDER</button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4 col-md-5 col-sm-5 shipping-info">
                            <!--<h3 class="c-title mt75">Order Activity</h3>-->
                            <h3 class="c-title mt75">Customer Detail</h3>
                            <div class="table-responsive no-border">
                              <table class="table  table-responsive   customer-detail-table">
                                <tr>
                                  <td colspan="2"><span class="green-color">Name:</span> {{ name }}</td>
                                </tr>
                                <tr>
                                  <td><span class="green-color">Phone:</span> {{ order.phone }}</td>
                                  <td><span class="green-color">Area:</span> {{ order.area }}</td>
                                </tr>
                                <tr>
                                  <td colspan="2" v-if="order.delivery_time"><span class="green-color">Delivery
                                      Time:</span> {{ order.delivery_time }}</td>
                                  <td colspan="2" v-else><span class="green-color">Delivery Time:</span> Regular
                                    Delivery</td>
                                </tr>
                                <tr>
                                  <td colspan="4">
                                    <span class="green-color">Shipping Address:</span>
                                    <div> {{order.address}} </div>
                                  </td>
                                </tr>
                              </table>
                            </div>

                            <h3 class="c-title mt15">Order Tracking</h3>
                            <div class="order-activity">
                              <div class="steps">
                                <div class="step is-complete">
                                  <div class="line"></div>
                                  <!--receive-->
                                  <div class="icon-box receive"><img src="@/assets/images/icons/order.png"
                                                                     class="img-responsive" alt=""></div>
                                  <div class="step-tag">
                                    <span class="step-title">ORDER RECEIVED</span><br>
                                    <div class="tracking-meta">

                                      <strong>{{order.created_at | formatDateTime }} {{order.created_at | findNumberOfDays }}</strong>
                                   
                                    </div>

                                  </div>
                                </div>

                                <div class="step" v-bind:class="{ 'is-complete': order.approve_date != null, 'is-pending': order.approve_date == null }">
                                  <div class="line"></div>
                                  <!--approve-->
                                  <div class="icon-box " v-bind:class="{ approve: order.approve_date != null }"><img
                                    src="@/assets/images/icons/right.png" class="img-responsive" alt=""></div>
                                  <div class="step-tag">
                                    <span class="step-title">ORDER ACCEPTED</span><br>
                                    <div class="tracking-meta" v-if="order.approve_date">
                                      <span>Time</span>
                                      <strong>{{order.approve_date | formatDateTime }}</strong>
                                    </div>
                                    <div v-if="order.approve_date">{{order.approve_date | findNumberOfDays }}</div>
                                    <div v-else>pending</div>

                                  </div>
                                </div>

                                <div class="step" v-bind:class="{ 'is-complete': order.transit_date != null, 'is-pending': order.transit_date == null }">
                                  <div class="line"></div>
                                  <!--transit-->
                                  <div class="icon-box" v-bind:class="{ transit: order.transit_date != null }"><img
                                    src="@/assets/images/icons/truck.png" class="img-responsive" alt=""></div>
                                  <div class="step-tag">
                                    <span class="step-title">IN TRANSIT</span><br>
                                    <div class="tracking-meta" v-if="order.transit_date">
                                      <span>Time</span>
                                      <strong>{{order.transit_date | formatDateTime }}</strong>
                                    </div>
                                    <div v-if="order.transit_date"> {{order.transit_date | findNumberOfDays }}</div>
                                    <div v-else>pending</div>

                                  </div>
                                </div>
                                <div class="step is-cancelled" v-if="order.cancel_date != null">
                                  <div class="line"></div>
                                  <!--cancel-->
                                  <div class="icon-box" v-bind:class="{ cancel: order.cancel_date != null }"><img
                                    src="@/assets/images/icons/forbidden.png" class="img-responsive" alt=""></div>
                                  <div class="step-tag">
                                    <span class="step-title">CANCEL ORDER</span><br>
                                    <div class="tracking-meta">
                                      <span>Time</span>
                                      <strong>{{order.cancel_date | formatDateTime }}</strong>
                                    </div>
                                    <div v-if="order.cancel_date"> {{order.cancel_date | findNumberOfDays }}</div>
                                    <div v-else>pending</div>

                                  </div>
                                </div>
                                <div class="step" v-if="order.cancel_date == null" v-bind:class="{ 'is-complete': order.delivered_date != null, 'is-pending': order.delivered_date == null }">
                                  <div class="line"></div>
                                  <!--delivered-->
                                  <div class="icon-box" v-bind:class="{ delivered: order.delivered_date != null }"><img
                                    src="@/assets/images/icons/pin.png" class="img-responsive" alt=""></div>
                                  <div class="step-tag">
                                    <span class="step-title">DELIVERED</span><br>
                                    <div class="tracking-meta" v-if="order.delivered_date">
                                      <span>Time</span>
                                      <strong>{{order.delivered_date | formatDateTime }}</strong>
                                    </div>
                                    <div v-if="order.delivered_date"> {{order.delivered_date | findNumberOfDays }}</div>
                                    <div v-else>pending</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!--<h3 class="c-title" v-if="order.courier_details!=null">Courier  Information</h3>-->
                            <!--<div class="order-activity"  v-if="order.courier_details!=null">-->
                            <!--<div class="pdlr15">Courier TRN ID: <span class="base-color"> {{ order.courier_trn_id }}</span> <br>{{ order.courier_details }}</div>-->

                            <!--</div>-->
                            <div class="text-center">
                              <!--@click="print()"-->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
const $ = require('jquery');
window.$ = $;
$(function () {
  $(window)
    .scroll(function () {
      $('nav')
        .toggleClass('scrolled', $(this)
          .scrollTop() > 20);
    });
});

import axios from 'axios';

export default {
  data() {
    return {
      token: '',
      products: [],
      getcarts: [],
      modalProductData: [],
      recentViews: [],
      categories: [],
      carts: [],
      loadMore: true,
      isOpen: true,
      sum_cart_total: '',
      quantity: 1,
      images: [],
      parseCartData: [],
      changeModalGallery_image: '',
      fullname: '',
      deliveryAddress: '',
      orders: [],
      shppings: [],
      order_items: [],
      name: '',
      email: '',
      finalOrderStatus: '',
      phone: '',
      country: '',
      district: '',
      area: '',
      zip: '',
      address: '',
    };
  },
  created: function () {
    this.loadApiData();
    this.fetchUserInfo();
    //localStorage.clear();

  },
  mounted() {
    let vm= this;
    if (localStorage.getItem("token")) {
      let vm = this;
      vm.token = localStorage.getItem("token");
    }
    if (localStorage.getItem("carts")) {
      vm.carts = JSON.parse(localStorage.getItem("carts"));
    } else {
      vm.carts = [];
    }
    this.calculateCartTotal();
  },
  methods: {

    // finalStatus: function(orderID){
    //    //console.log(orderID);
    //    if(orderID ==3 || orderID ==4){
    //      return true;
    //    }else{
    //      return  false;
    //    }
    // },
    openCancelModal: function(orderID){
      localStorage.setItem("cancelOrderID", orderID);
    },
    cancelThisOrder: function () {
      let OrderID = localStorage.getItem("cancelOrderID");
      axios.post(this.globalUrl + 'cancel-order',
        {
          this_order_id: OrderID,
          user_id: localStorage.getItem('logged_in_user_id')
        }, {crossdomain: true, headers: {
            Authorization: localStorage.getItem("token")
          }})
        .then((response) => {
          //console.log(response);
          if (response.data.status == 1) {
            this.$toasted.show('Order has  been cancelled successfully', {
              type: 'success',
              icon: 'fa-exclamation-triangle',
              duration: 10000
            });
            this.$router.go();

          } else {
            this.$toasted.show('Something wrong. Please Try Again', {
              type: 'error',
              icon: 'fa-exclamation-triangle',
              duration: 10000
            });
          }
        })
        .catch((response) => {
          // console.log(response);

        });

    },
    orderTotal: function (amount, delivery, coupon_discount) {

      return parseFloat(amount) + parseFloat(delivery) - parseFloat(coupon_discount);
    },
    print: function () {
      window.print();
    },
    fetchUserInfo() {
      this.name = JSON.parse(localStorage.getItem("userinfo")).name;
      this.email = JSON.parse(localStorage.getItem("userinfo")).email;
      this.phone = JSON.parse(localStorage.getItem("userinfo")).phone;
      this.country = JSON.parse(localStorage.getItem("userinfo")).country;
      this.district = JSON.parse(localStorage.getItem("userinfo")).district;
      this.area = JSON.parse(localStorage.getItem("userinfo")).area;
      this.zip = JSON.parse(localStorage.getItem("userinfo")).zip;
      this.address = JSON.parse(localStorage.getItem("userinfo")).address;
    },
    loadApiData: function () {
      //localStorage.clear();
      let vm = this;
      //vm.$parent.startLoading();
      let logged_in_user_id = localStorage.getItem('logged_in_user_id');

      axios.get(this.globalUrl + "myorders/" + logged_in_user_id, {
        crossdomain: true,
        headers: {
          Authorization: localStorage.getItem("token")
        }
      })
        .then(response => {
          // Handle successful response
          // Assuming response.data.data contains the orders

          // Filter out duplicate orders based on their 'id'
          const uniqueOrders = response.data.data.reduce((uniqueArr, order) => {
            // Check if the order id is already in uniqueArr
            if (!uniqueArr.some(item => item.id === order.id)) {
              uniqueArr.push(order);
            }
            return uniqueArr;
          }, []);

          console.log(uniqueOrders);
          this.orders = uniqueOrders;

        })
        .catch(error => {
          // Handle errors
          console.error('Error fetching orders:', error);
          // end loading (if applicable)
          // this.$parent.endLoading();
        });
      //alert(this.globalUrl+"myorders/"+logged_in_user_id+"/items");
      axios.get(this.globalUrl + "myorders/" + logged_in_user_id + "/items"
        , {
          crossdomain: true,
          headers: {
            Authorization: localStorage.getItem("token")
          }
        }
      )
        .then(function (response) {
          vm.order_items = response.data.data;
        })
        .catch((response) => {
        });
    },
    calculateCartTotal() {
      let vm = this;
      for (var i = 0, sum = 0; i < vm.carts.length; sum += vm.carts[i++].subtotal) ;
      vm.sum_cart_total = sum;
      //calculate total  product  amount
      for (var i = 0, totalSum = 0; i < vm.carts.length; totalSum += vm.carts[i++].cart_quantity) ;
      vm.cartsCountProduct = totalSum;
      localStorage.setItem("cartsCountProduct", totalSum);
      $(".carts .badge")
        .text(vm.carts.length);
    },
    increment() {
      this.quantity++;
    },
    decrement() {
      if (this.quantity === 1) {

      } else {
        this.quantity--;
      }
    },
    cartIncrement(product_id) {
      //alert(product_id);
      let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
      let oldQuantity = this.carts[objIndex].cart_quantity;
      let newQuantity = oldQuantity + 1;
      let price = this.carts[objIndex].price;
      this.carts[objIndex].cart_quantity = newQuantity;
      this.carts[objIndex].subtotal = price * newQuantity;
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.carts = JSON.parse(localStorage.getItem("carts"));
      this.calculateCartTotal();
      $("#" + product_id)
        .addClass("animated");
      setTimeout(function () {
        $("#" + product_id)
          .removeClass("animated");
      }, 500);
    },
    cartDecrement(product_id) {
      let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
      let oldQuantity = this.carts[objIndex].cart_quantity;
      if (oldQuantity > 1) {
        let newQuantity = oldQuantity - 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        $("#" + product_id)
          .addClass("animated");
        setTimeout(function () {
          $("#" + product_id)
            .removeClass("animated");
        }, 500);
      }

    },
    removeCartItem: function (product_id) {
      //alert(product_id);
      this.carts = this.carts.filter((e) => e.product_id !== product_id);
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.calculateCartTotal();
    }
  }
};
</script>
